var core = module.exports = {version: '1.2.6'};
if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef


//////////////////
// WEBPACK FOOTER
// ./~/react-attrs-filter/~/core-js/library/modules/$.core.js
// module id = 461
// module chunks = 0